import classes from '~/config/classes'

export default class ProductFormUpsell extends HTMLElement {
  constructor() {
    super()
    this.addButton = this.querySelector('[js-add-to-bag]')
    this.addLabel = this.querySelector('[js-add-label]')
    this.spinner = this.querySelector('[js-spinner]')
    this.select = this.querySelectorAll('[js-select]')
    this.showBundle = this.querySelector('[js-show-bundle]')
    this.bundle = this.querySelector('[js-upsell-bundle]')
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
    this.productData = this.querySelector('[js-upsell-data]')
    this.variants = this.productData ? JSON.parse(this.productData.textContent) : null
  }

  connectedCallback() {
    this.addButton.setAttribute('disabled', true)

    if (!this.variants) {
      return
    }

    if (this.addButton) {
      this.addButton.addEventListener('click', this.addToBag.bind(this))
    }

    if (this.select) {
      this.select.forEach((select) => {
        select.addEventListener('change', () => {
          const selectVariant = this.getVariant()

          if (selectVariant?.available) {
            this.addButton.removeAttribute('disabled')
            return
          }

          this.addButton.setAttribute('disabled', true)
        })
      })
    }

    if (this.showBundle) {
      this.showBundle.addEventListener('click', () => {
        if (this.bundle) {
          this.bundle.classList.remove('visually-hidden')
          this.showBundle.classList.add('is-hidden')
        }
      })
    }
  }

  async addToBag() {
    if (!this.select) {
      return
    }

    let variantId

    if (this.isMultiOption()) {
      const { id } = this.getVariant()
      if (!id) {
        return
      }

      variantId = id
    } else {
      variantId = this.select[0].value
    }

    try {
      this.spinner.classList.remove('hidden')
      this.addLabel.classList.add(classes.hidden)

      if (!variantId) {
        console.error('[Product Form Upsell]', 'Missing variant ID')
        return
      }

      const data = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }

      if (this.cart) {
        data.sections = this.cart.getSectionsToRender().map((section) => section.id)
        data.sections_url = window.location.pathname
      }

      const json = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }).then(response => response.json())

      if (this.cart && this.cart.enableCartDrawer) {
        this.cart.renderContents(json)
        this.cart.open(this.addButton)
      } else if (window.SLIDECART) {
        window.SLIDECART_UPDATE()
        window.SLIDECART_OPEN()
      }

      this.spinner.classList.add('hidden')
      this.addLabel.classList.remove(classes.hidden)
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form-upsell',
        productVariantId: variantId,
        cartData: json,
      })
    } catch (error) {
      this.spinner.classList.add('hidden')
      this.addLabel.classList.remove(classes.hidden)
      console.error('[Product Form Upsell]', error)
    }
  }

  getVariant() {
    let selectedVariant
    const variantOptions = Array.from(this.select).map((select) => {
      return select.value
    })

    if (this.isMultiOption()) {
      selectedVariant = this.variants.find((variant) => {
        return variantOptions.every((val, index) => {
          return val === variant.options[index]
        })
      })
    } else {
      selectedVariant = this.variants.find((variant) => {
        return variantOptions[0] === variant.id.toString()
      })
    }

    if (selectedVariant) {
      return selectedVariant
    }

    return false
  }

  isMultiOption() {
    return this.select.length > 1
  }
}
